import React from 'react';
import Navbar from '../../components/navbar';
import InfoCargaMasiva from '../../components2/infoCargaMasiva';

function CargaMasiva () {
    return (
        <InfoCargaMasiva />
    )
}

export default CargaMasiva;